var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      attrs: {
        id: "colorContrast",
        horizontal: "",
        "label-cols": "3",
        "label-size": "md",
        label: _vm.$t("labels.colorContrast") + ":"
      }
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { lg: "5" } }, [
            _c(
              "label",
              { staticClass: "customi_label", attrs: { for: "Regular" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contrast,
                      expression: "contrast"
                    }
                  ],
                  staticClass: "invisible customi_input",
                  attrs: {
                    type: "radio",
                    id: "Regular",
                    name: "contrast",
                    value: "Regular"
                  },
                  domProps: { checked: _vm._q(_vm.contrast, "Regular") },
                  on: {
                    change: function($event) {
                      _vm.contrast = "Regular"
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "customi_div radio" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "customi_svg",
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "svg_bg",
                        attrs: { cx: "10", cy: "10", r: "9" }
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "svg_top radio_check",
                        attrs: { cx: "10", cy: "10", r: "6" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("labels.normal")))])
              ]
            )
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { lg: "5" } }, [
            _c(
              "label",
              { staticClass: "customi_label", attrs: { for: "HighContrast" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contrast,
                      expression: "contrast"
                    }
                  ],
                  staticClass: "invisible customi_input",
                  attrs: {
                    type: "radio",
                    id: "HighContrast",
                    name: "contrast",
                    value: "HighContrast"
                  },
                  domProps: { checked: _vm._q(_vm.contrast, "HighContrast") },
                  on: {
                    change: function($event) {
                      _vm.contrast = "HighContrast"
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "customi_div radio" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "customi_svg",
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "svg_bg",
                        attrs: { cx: "10", cy: "10", r: "9" }
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "svg_top radio_check",
                        attrs: { cx: "10", cy: "10", r: "6" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("labels.highContrast")))])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Settings/colorContrast.vue?vue&type=template&id=fc0760d8&
// module id = null
// module chunks = 